import graphql from 'babel-plugin-relay/macro'
import React, { Component } from 'react'
import { createPaginationContainer } from 'react-relay'
import styled from 'styled-components'

import { markMessageAsReadWithFetch } from '../../api'
import { MessageRow } from './MessageRow'

const Container = styled.div`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 16px;
  min-height: 240px;
`

const List = styled.div`
  display: flex;
  flex-direction: column-reverse;
`

// const ListHeader = styled.div`
//   height: 99vh;
//   display: flex;
//   flex-direction: column-reverse;
//   padding-bottom: 32px;
//   font-size: 1.1em;
// `

// const Button = styled.button`
//   font-family: 'Open Sans', sans-serif;
//   font-size: 1em;
//   margin-left: 16px;
//   padding: 16px;
//   border: transparent;
//   background-color: transparent;
//   color: '#48b1bf';
// `

class Messages extends Component {
  state = {
    loading: false
  }

  componentDidMount () {
    setTimeout(this.scrollToEndOfMessages, 2000)

    const { viewer: { id, messages }, userId } = this.props

    if (userId) {
      const unreadMessages = messages.edges.filter(({ node }) => !node.readBy.includes(userId))
      unreadMessages.map(async e => markMessageAsReadWithFetch({ messageId: e.node.id, userId, conversationId: id }))
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.innerHTML = `
      $('#messageList').on('scroll', function() {
        var scrollTop = $(this).scrollTop();
        if (scrollTop + $(this).innerHeight() >= this.scrollHeight) {
        } else if (scrollTop < 8) {
          window.messagesRef.onLoadMore()
          $(this).scrollTop(8)
        } else {
        }
      });
    `
    document.body.appendChild(script)
  }

  componentDidUpdate () {
    // this.scrollToEndOfMessages()
  }

  scrollToEndOfMessages = () => {
    const messagesList = document.getElementById('messageList')
    messagesList.scrollTop = messagesList.scrollHeight
  }

  onLoadMore = async e => {
    // e && e.preventDefault()
    e && e.stopPropagation()

    const { relay } = this.props
    const more = relay.hasMore()
    const loading = relay.isLoading()
    if (!more || loading) return false

    this.setState({ loading: true })
    relay.loadMore(2, err => this.setState({ loading: false }))
  }

  // renderMoreContainer = () => {
  //   const { viewer: { title, type }, relay, t } = this.props
  //   const { loading } = this.state
  //   if (!loading) return null

  //   return (
  //     <i className="fa fa-circle-o-notch fa-spin"></i>
  //   )
  //   // const more = relay.hasMore()
  //   // if (more) {
  //   //   return (
  //   //     <Button onClick={this.onLoadMore}>load more</Button>
  //   //   )
  //   // }

  //   // return (
  //   //   <ListHeader>
  //   //     {type !== 'BROADCAST' && <div dangerouslySetInnerHTML={{ __html: 'asdf'/*t('conversation_beginning_of_conversation', { title })*/ }} />}
  //   //   </ListHeader>
  //   // )
  // }

  render () {
    const { viewer: { messages } } = this.props
    const { loading } = this.state

    return (
      <Container id='messageList'>
        {loading && <i className="fa fa-circle-notch fa-spin"></i>}
        <List>
          {messages.edges.map(({ node }) => <MessageRow key={node.id} message={node} />)}
          {/* {this.renderMoreContainer()} */}
        </List>
      </Container>
    )
  }
}

const MessagesContainer = createPaginationContainer(
  Messages, {
  viewer: graphql`
    fragment Messages_viewer on Conversation @argumentDefinitions(after: { type: "Cursor" }) {
      id
      shortId
      title
      type
      messages: messagesByConversationId(first: 16, after: $after) @connection(key: "Conversation_messages") {
        totalCount
        edges {
          node {
            id
            createdAt
            readBy
            ...MessageRow_message
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }`
  }, {
    direction: 'forward',
    query: graphql`
      query MessagesQuery($shortId: String!, $after: Cursor) {
        conversation: conversationByShortId(shortId: $shortId) {
          ...Messages_viewer @arguments(after: $after)
        }
      }
    `,
    getConnectionFromProps: props => props.viewer.messages,
    getFragmentVariables: (previousVars, pageSize) => ({
      ...previousVars,
      pageSize
    }),
    getVariables: (props, paginationInfo) => ({
      shortId: props.viewer.shortId,
      after: paginationInfo.cursor || paginationInfo.after
    })
  }
)

export { MessagesContainer as Messages }
